import { initAmpli } from "./ampli";
import { initGtm } from "./gtm";

/** Initialize third-party integrations once at app startup, before render. */
export function initExternalIntegrations(): void {
  initAmpli();
  initGtm();
}
